module.exports = __webpack_public_path__ + "static/img/allschool.4f4b7bef.png";